export default __webpack_public_path__ + "static/media/city_vb.e3386df9.png";